import React, { FC } from 'react';
import { Button } from '@npm-registry/eapteka-ui';
import { text } from '../../../../text';
import styles from './Submit.scss';
import { useSubmit } from './hooks/useSubmit';

interface SubmitProps {
  price: string;
  disabled: boolean;
}

export const Submit: FC<SubmitProps> = ({
  price = '',
  disabled = false
}) => {
  const { onClick } = useSubmit();

  return (
    <Button
      className={styles.button}
      disabled={disabled}
      onClick={onClick}
    >
      <span>{text['summary.submit']}</span>
      <span className={styles.price}>{price}</span>
    </Button>
  );
};
